const appRoot = "/app";

export const routes = {
  attributeGroup: `${appRoot}/menu/configure/:menu_id/attribute-group`,
  callCenter: `${appRoot}/call-center`,
  configureMenu: `${appRoot}/menu/configure/:aggregator/:menuId/:is_discount`,
  configureIIKOMenu: `${appRoot}/menu/configure-iiko/:menuId`,
  analytics: `${appRoot}/analytics`,
  createMenuSuccess: `${appRoot}/createMenu/success`,
  location: `${appRoot}/location`,
  matchMenu: `${appRoot}/createMenu/match-menu/:menuId`,
  menu: `${appRoot}/menu`,
  order: `${appRoot}/orders`,
  activeOrders: `${appRoot}/orders/active`,
  promo: `${appRoot}/promotions`,
  publicationMenu: `${appRoot}/publication-menu`,
  stopList: `${appRoot}/stopList`,
  stopListBalance: `${appRoot}/stopListBalance`,
  timeSetting: `${appRoot}/time-settings`,
  uploadMenu: `${appRoot}/createMenu/upload-file`,
  posSettings: `${appRoot}/pos-settings`,
  access: `${appRoot}/access`,
  cron: `${appRoot}/cron`,
};
export const menu_routes = {
  create_product: "create-product",

  edit: "edit",

  edit_product: "edit-product/:product_id",

  edit_attribute_group:
    "edit-product/:product_id/edit-attribute-group/:attribute_group_id",

  select_all: "edit-product/:product_id/select-all",
};
